import "./PackageSection.css";
import { Link } from "react-router-dom";
import { PackageCard } from "./PackageCard";
import mukafall from "../media/tourism/Mukha fall/fall1.jpeg";
import dubai from "../media/dubai.jpg";
import europe from "../media/europebg.jpg";
import fossils from "../media/tourism/Fossils Park/fossils1.jpeg";
import rock from "../media/tourism/Canvas Rock Painting/rock5.jpg";
import Shiva from "../media/tourism/Shiv Dwar/shiv1.jpg";
import vijayfort from "../media/tourism/Vijaygarh Fort/fort2.jpg";
import dam from "../media/tourism/Rihand Dam/dam3.jpeg";
import abadi from "../media/tourism/Abadi Picnic Spot/abadi2.jpg";
import rajdari from "../media/tourism/other/Rajdari Devdari/1.jpg";
import varanasi from "../media/tourism/other/Varanasi/107570888.jpg";
import prayag from "../media/tourism/other/Allahabad/430878150_721838313437533_8365993422936757979_n.jpg";
import vindhyachal from "../media/tourism/other/Vindhyachal/444481078_775854848026942_3025085871748325057_n.jpg";
import mundeshwari from "../media/tourism/other/Maa Mundeshwari/cq5dam.web_.2000.765-3_REF-1.jpg";

export const PackageSection = () => {
  const packageInfoRow1 = [

    {
      place: "Varanasi - Kashi",
      info: "Discover the Timeless Beauty of Varanasi: The Spiritual Heart of India",
      img: varanasi,
      price: "4000-5000 INR",
      placename: "varanasi-kashi",
    },
    {
      place: "Allahabad - Prayagraj - Kumbh City",
      info: "The Sangam City, India’s Freedom history and much more",
      img: prayag,
      price: "4000-5000 INR",
      placename: "allahabad-prayagraj",
    },
    {
      place: "Vindhyachal Temple Mirzapur",
      info: "A Divine Pilgrimage to the Abode of Goddess Vindhyavasini at Mirzapur",
      img: vindhyachal,
      price: "4000-5000 INR",
      placename: "vindhyachal",
    },
    {
      place: "Mukha Fall",
      info: "Scenic beauty of river belan falling from a height of 100 ft",
      img: mukafall,
      price: "4000-5000 INR",
      placename: "mukhafall",
    },
    {
      place: "Rihand Dam",
      info: "Largest dam of India by volume",
      img: dam,
      price: "4000-5000 INR",
      placename: "rihanddam",
    },
    {
      place: "Fossils Park",
      info: "Asia's oldest and Over 150 Crore year old fossils park",
      img: fossils,
      price: "4000-5000 INR",
      placename: "fossilspark",
    },
    {
      place: "ShivDwar Temple",
      info: "11th Century Temple of Lord Shiva and Goddess Parvati",
      img: Shiva,
      price: "4000-5000 INR",
      placename: "shivdwartemple",
    },
    {
      place: "Vijaygarh Fort",
      info: "Built at time of Mahabharata and still alive",
      img: vijayfort,
      price: "4000-5000 INR",
      placename: "vijaygarhfort",
    },
    {
      place: "Aabadi Picnic Spot",
      info: "Known as Mini Goa of Sonbhadra: Lush green forests meet serene valleys and river",
      img: abadi,
      price: "4000-5000 INR",
      placename: "abadipicnic",
    },
    {
      place: "Rajdari and Devdari Waterfalls",
      info: "Waterfalls, surrounded by rugged cliffs, lush greenery, and serene valleys, with gravity magic",
      img: rajdari,
      price: "4000-5000 INR",
      placename: "devdari-rajdari-waterfall",
    },
    {
      place: "Maa Mundeshwari Temple",
      info: "India’s Oldest Functional Temple and a Sacred Pilgrimage Destination",
      img: mundeshwari,
      price: "4000-5000 INR",
      placename: "mundeshwari",
    },
    {
      place: "Cave Paintings",
      info: "Over 4000 years old Rock paintings, showing culture",
      img: rock,
      price: "4000-5000 INR",
      placename: "cavepaintings",
    },
  ];
  //const packageInfoRow2 = [
    // {
    //   place: "dubai",
    //   info: "Lorem ipsum dolor sit amet consectetur adipisicing elit.Praesentium repellat repudiandae iste veritatis cumque vitae!",
    //   img: dubai,
    //   price: "4000-5000 INR",
    // },
    // {
    //   place: "europe",
    //   info: "Lorem ipsum dolor sit amet consectetur adipisicing elit.Praesentium repellat repudiandae iste veritatis cumque vitae!",
    //   img: europe,
    //   price: "4000-5000 INR",
    // },
    
  //];
  return (
    <>
      <div className="container3">
        <section className="packages" id="packages">
          <div className="outerbox">
            <h1>
              Top Places
              <hr />
            </h1>
            <p>
          Below is list of Top Places to visit with Sonbhadra Tourism. We offer our services for all the mentioned locations at very less cost. For more details see our Tour Packages.
        </p>
            <div className="row1">
              {packageInfoRow1.map((element) => {
                return (
                  <PackageCard
                  key={element.placename}
                    placeName={element.place}
                    img={element.img}
                    info={element.info}
                    // price={element.price}
                    location={element.place}
                    locationname={element.placename}
                  />
                );
              })}
            </div>
            {/* <h2>
              International
              <hr />
            </h2>
            <div className="row2">
              {packageInfoRow2.map((element) => {
                return (
                  <PackageCard
                    placeName={element.place}
                    img={element.img}
                    info={element.info}
                    price={element.price}
                    location={element.place}
                  />
                );
              })}
            </div> */}
            <div className="morebtn">
              <Link to="/locations">
                <button className="more-btn">See All Places</button>
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
